import queryString from 'query-string';

export const formatDate = (date, locale = 'de', short = false) => {

    const localeMap = {
        'de': 'de-AT',
        'it': 'it-IT',
        'en': 'en-GB'
    };

    if (short) {
        return new Intl.DateTimeFormat('de-AT', {
            day: '2-digit',
            month: '2-digit'
        }).format(date);
    }

    const intlLocale = localeMap[locale] || localeMap['de'];
    let formattedDate = new Intl.DateTimeFormat(intlLocale, {
        day: '2-digit',
        month: 'short'
    }).format(date);

    return formattedDate.endsWith('.') ? formattedDate.slice(0, -1) : formattedDate;
};

export const haversineDistance = (() => {
    const toRadians = Math.PI / 180;
    const earthRadiusKm = 6371;

    return (latitude1, longitude1, latitude2, longitude2) => {
        const deltaLatitude = (latitude2 - latitude1) * toRadians;
        const deltaLongitude = (longitude2 - longitude1) * toRadians;
        const latitude1InRadians = latitude1 * toRadians;
        const latitude2InRadians = latitude2 * toRadians;

        const a = Math.sin(deltaLatitude / 2) * Math.sin(deltaLatitude / 2) +
            Math.cos(latitude1InRadians) * Math.cos(latitude2InRadians) *
            Math.sin(deltaLongitude / 2) * Math.sin(deltaLongitude / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return earthRadiusKm * c;
    };
})();

export const parseQueryParams = (location) => {
    const params = queryString.parse(location.search, {arrayFormat: 'bracket'});
    return Object.keys(params).reduce((param, key) => {
        if (Array.isArray(params[key])) {
            param[key] = params[key].map(Number);
        } else if (!isNaN(params[key])) {
            param[key] = Number(params[key]);
        } else {
            param[key] = params[key];
        }
        return param;
    }, {});
};

export const getRoomsFromFilters = (selectedFilters) => {
    const rooms = [];
    let index = 0;

    while (`adults-${index}` in selectedFilters || `childs-${index}` in selectedFilters) {
        const adults = selectedFilters[`adults-${index}`] || 0;
        const children = selectedFilters[`childs-${index}`] || 0;
        const childAges = [];

        let childIndex = 1;
        while (`childAge${index}-${childIndex}` in selectedFilters) {
            childAges.push(selectedFilters[`childAge${index}-${childIndex}`]);
            childIndex++;
        }

        rooms.push({adults, children, childAges});
        index++;
    }

    return rooms;
};

export const getTotalPax = (rooms) => {
    return rooms.reduce((acc, room) => acc + room.adults + room.children, 0);
};

export const translate = (path, variables = {}) => {

    let translation = path.split('.').reduce((acc, part) => acc && acc[part], window._translations);

    if (!translation) {
        return null;
    }

    for (const [key, value] of Object.entries(variables)) {
        const placeholder = `{${key}}`;
        const regex = new RegExp(placeholder, 'g');
        translation = translation.replace(regex, value);
    }

    return translation;
};